import { render, staticRenderFns } from "./ActionsConfig.vue?vue&type=template&id=1e57af20"
import script from "./ActionsConfig.vue?vue&type=script&lang=js"
export * from "./ActionsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports